import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/webapp-component-ui/webapp-component-ui/doc/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "documentation-for-cosmotechui-components"
    }}>{`Documentation for @cosmotech/ui components`}</h1>
    <p>{`Documentation for the UI components of `}<a parentName="p" {...{
        "href": "https://github.com/Cosmo-Tech/azure-sample-webapp"
      }}>{`Cosmo Tech Azure Sample Webapp`}</a>{`.
This project documents and shows how to use the components.`}</p>
    <p>{`We use `}<a parentName="p" {...{
        "href": "https://github.com/doczjs/docz"
      }}>{`docz`}</a>{` to build our documentation.`}</p>
    <h2 {...{
      "id": "build--host-documentation-locally"
    }}>{`Build & host documentation locally`}</h2>
    <p>{`Start with `}<inlineCode parentName="p">{`yarn install`}</inlineCode>{` to install all dependencies requried to build the documentation.
Then, you can use `}<inlineCode parentName="p">{`yarn docz:dev`}</inlineCode>{` to build the documentation and serve it locally at http://localhost:3000/ (default).`}</p>
    <h2 {...{
      "id": "build-documentation"
    }}>{`Build Documentation`}</h2>
    <p><inlineCode parentName="p">{`yarn docz:build`}</inlineCode>{` will generate a static site for your site in `}<inlineCode parentName="p">{`.docz/dist/`}</inlineCode>{`.`}</p>
    <p>{`You can try it out with `}<inlineCode parentName="p">{`yarn docz:serve`}</inlineCode>{` or by serving the generated site with your favorite static file server (e.g. `}<inlineCode parentName="p">{`npx serve .docz/dist`}</inlineCode>{`).
Be careful if you have specified a `}<inlineCode parentName="p">{`base`}</inlineCode>{` config in your `}<strong parentName="p">{`doczrc.js`}</strong>{` it's not used in `}<inlineCode parentName="p">{`yarn docz:serve`}</inlineCode>{`
By default the `}<inlineCode parentName="p">{`base`}</inlineCode>{` config is specified for automatic deployment on our Github pages.`}</p>
    <p>{`You can have `}<inlineCode parentName="p">{`yarn docz:build`}</inlineCode>{` emit to a different directory by providing a path to the `}<inlineCode parentName="p">{`dest`}</inlineCode>{` field in your `}<strong parentName="p">{`doczrc.js`}</strong>{` or from the command line : `}<inlineCode parentName="p">{`yarn docz:build --dest docs-site-directory`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "deploy-documentation"
    }}>{`Deploy Documentation`}</h2>
    <p>{`The output of docz consists of static assets only. This allows you to deploy your generated `}<inlineCode parentName="p">{`docz`}</inlineCode>{` site with any static site hosting provider you'd like.`}</p>
    <p>{`Start by building your site with `}<inlineCode parentName="p">{`yarn docz:build`}</inlineCode>{`, if you haven't provided a `}<inlineCode parentName="p">{`dest`}</inlineCode>{` flag to your config then you will find your generated files in `}<inlineCode parentName="p">{`.docz/dist`}</inlineCode>{` to copy to the server.`}</p>
    <h2 {...{
      "id": "clean-docz-dependencies"
    }}>{`Clean docz dependencies`}</h2>
    <p>{`To remove docz build and clear dependencies, run `}<inlineCode parentName="p">{`yarn docz:clean`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      